export class DOMNameSpaces
{ 
  static readonly SVG   = 'http://www.w3.org/2000/svg';
  static readonly XLink = 'http://www.w3.org/1999/xlink';
}